import { useEffect, useState } from "react";

export function useNowSecondTick(): number {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    setNowMs(Date.now());

    const update = () => setNowMs(Date.now());
    const alignMs = 1_000 - (Date.now() % 1_000);
    let intervalId: number | null = null;

    const alignTimer = window.setTimeout(() => {
      update();
      intervalId = window.setInterval(update, 1_000);
    }, alignMs);

    return () => {
      window.clearTimeout(alignTimer);
      if (intervalId !== null) {
        window.clearInterval(intervalId);
      }
    };
  }, []);

  return nowMs;
}
